<template>
  <div class="dashboard-table">
    <!-- Application Chat module -->
    <b-modal ref="applicationChatModal" @hidden="onApplicationModalClose" hide-footer>
      <div class="AliifChat-chatbox">
        <div class="chat-header" style="background-color: #5367ff">
          <h5 style="color: #fff" class="m-0">Away Education</h5>
        </div>
        <div class="chat-messages">
          <b-row v-for="(c, index) in applicationChat" :key="'ac_' + index">
            <div class="message ml-2 mb-2">
              <div class="user-info">
                <span class="user-name">
                  {{ `${c.user_firstname} ${c.user_lastname}` }}
                </span>
                <span class="user-type">
                  {{ c.user_type_tag || c.user_type_name }}
                </span>
              </div>
              <div class="message-text">
                <span class="message-content">{{ c.message }}</span>
                <sub class="message-timestamp">{{
                  getDateTimeFormatted(c.created_at)
                }}</sub>
              </div>
            </div>
          </b-row>
        </div>
        <div class="chat-input">
          <b-row class="mb-3 mx-0">
            <b-col cols="9">
              <b-form-textarea type="textarea" placeholder="Enter Message" class="border-0" cols="5" @keypress="(e) => {
                  if (e.key === 'Enter') {
                    sendApplicationMessage();
                    e.preventDefault();
                  }
                }
                " maxlength="5000" v-model="chatMessage" />
            </b-col>
            <b-col cols="3">
              <button @click="sendApplicationMessage" class="btn btn-primary">
                SEND
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>

    <!-- Course Details Modal -->
    <b-modal ref="detailModal" @hidden="onDetailModalClose" hide-footer size="xl">
      <div class="custom-modal-content">
        <div class="row">
          <!-- GENERAL ELIGIBILITY -->
          <div class="mb-2 col-12 col-md-4">
            <div class="course-detail__sm-title mb-1">General Eligibility</div>
            <div>
              {{
                popupData && popupData.general_eligibility
                  ? popupData.general_eligibility
                  : "NA"
              }}
            </div>
          </div>
          <!-- LANGUAGE REQUIREMENT -->
          <div class="mb-2 col-12 col-md-4">
            <div class="course-detail__sm-title mb-1">Language Requirement</div>
            <!-- <div>{{ languages_requirement }}</div> -->
            <div>
              {{
                popupData && popupData.languages_requirement
                  ? popupData.languages_requirement
                  : "NA"
              }}
            </div>
          </div>
          <!-- ADDITIONAL INFORMATION -->

          <!-- INTAKES -->
          <div class="mb-2 mb-md-0 col-12 col-md-4">
            <div class="course-detail__sm-title mb-1">Intake</div>
            <div>
              <span class="mr-1">Intake Start:</span>
              <span>{{
                popupData && popupData.intake ? popupData.intake : "NA"
              }}</span>
            </div>
            <div class="my-2">
              <div>
                <span class="mr-1">Intake Start:</span><span>{{
                  popupData && popupData.intake_start
                    ? popupData.intake_start
                    : "NA"
                }}</span>
              </div>
              <div>
                <span class="mr-1">Intake End:</span><span>{{
                  popupData && popupData.intake_end
                    ? popupData.intake_end
                    : "NA"
                }}</span>
              </div>
            </div>

            <div>
              <span class="mr-1">Intake Deadline 1:</span><span>{{
                popupData && popupData.intake_deadline_1
                  ? popupData.intake_deadline_1
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">Intake Deadline 2:</span><span>{{
                popupData && popupData.intake_deadline_2
                  ? popupData.intake_deadline_2
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">Intake Deadline 3:</span><span>{{
                popupData && popupData.intake_deadline_3
                  ? popupData.intake_deadline_3
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">Intake Deadline 4:</span><span>{{
                popupData && popupData.intake_deadline_4
                  ? popupData.intake_deadline_4
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">Intake Deadline 5:</span><span>{{
                popupData && popupData.intake_deadline_5
                  ? popupData.intake_deadline_5
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">Intake Deadline 6:</span><span>{{
                popupData && popupData.intake_deadline_6
                  ? popupData.intake_deadline_6
                  : "NA"
              }}</span>
            </div>
          </div>
          <!-- INTERNATIONAL SCHOLARSHIP DESCRIPTION -->
          <div class="col-12 col-md-4">
            <div class="course-detail__sm-title mb-1">
              International Scholarship Description
            </div>
            <!-- <div><p>{{ internation_scholarship_description }}</p></div> -->
            <div>
              <p>
                {{
                  popupData && popupData.internation_scholarship_description
                    ? popupData.internation_scholarship_description
                    : "NA"
                }}
              </p>
            </div>

            <div class="fs-14">
              <span class="font-bold mr-1">Scholarship Page Link:</span><a href="">{{
                popupData && popupData.scholarship_page_link
                  ? popupData.scholarship_page_link
                  : "NA"
              }}</a>
            </div>
          </div>
          <!-- GRE -->
          <div class="mb-2 col-12 col-md-4">
            <div class="course-detail__sm-title mb-1">Other</div>

            <div>
              <span class="mr-1">GRE Requirement:</span><span>{{
                popupData && popupData.gre_requirement
                  ? popupData.gre_requirement
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">GRE Score:</span><span>{{
                popupData && popupData.gre_score ? popupData.gre_score : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">SAT Requirement:</span><span>{{
                popupData && popupData.sat_requirement
                  ? popupData.sat_requirement
                  : "NA"
              }}</span>
            </div>
            <div>
              <span class="mr-1">SAT Score:</span><span>{{
                popupData && popupData.sat_score ? popupData.sat_score : "NA"
              }}</span>
            </div>
          </div>
          <!-- add -->
          <div class="col-12 col-md-4">
            <div class="course-detail__sm-title mb-1">
              Additional Information
            </div>
            <!-- <div><p>{{ internation_scholarship_description }}</p></div> -->
            <div class="fs-14">
              <span class="font-bold mr-1">Stem Course:</span><span>{{
                popupData && popupData.stem_course
                  ? popupData.stem_course
                  : "NA"
              }}</span>
            </div>
            <div class="fs-14">
              <span class="font-bold mr-1">Fifteen Years Education Acceptable:</span><span>{{
                popupData && popupData.fifteen_years_education_acceptable
                  ? popupData.fifteen_years_education_acceptable
                  : "NA"
              }}</span>
            </div>
            <div class="fs-14">
              <span class="font-bold mr-1">IELTS Waiver:</span><span>{{
                popupData && popupData.ielts_waiver
                  ? popupData.ielts_waiver
                  : "NA"
              }}</span>
            </div>
            <div class="fs-14">
              {{
                popupData && popupData.if_ielts_is_waived_conditions_for
                  ? popupData.if_ielts_is_waived_conditions_for
                  : "NA"
              }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <div v-if="['agent', 'franchise'].includes(user_type)" class="mb-2">
      <b-link @click="$router.push('/universitysearch')">
        <b-button variant="outline-primary">Add Application</b-button>
      </b-link>
    </div>

    <b-card>
      <b-tabs card>
        <!-- Applications -->
        <b-tab title="Student Applications">
          <!-- <template #header>
        <h2>Student Applications</h2>
      </template> -->

          <b-table ref="refStudentApplicationsTable" class="position-relative" :items="studentApplications" responsive
            :fields="studentApplicationsColumns" primary-key="course_id">
            <template #cell(university_name)="data">
              <div style="width: max-content">
                {{ data.value }}
              </div>
            </template>
            <template #cell(intake)="data">
              <div style="width: max-content">
                {{ formatCourseIntake(data.value) }}
              </div>
            </template>

            <template #cell(course_fee_pa)="data">
              <div style="width: max-content">
                {{ data.value.toLocaleString("en-IN") }}
                {{ data.item.currency }}
              </div>
            </template>
            <template #cell(course_year)="data">
              <div style="width: max-content">
                <div v-if="data.value">{{ data.value }} Year(s)</div>
                <div v-if="data.item.course_month" style="margin-top: 10px">
                  {{ data.item.course_month }} Month(s)
                </div>
              </div>
            </template>

            <template #cell(course_name)="data">
              <div style="width: max-content">
                {{ data.value }}
              </div>
              <div class="d-flex align-items-center">
                <!-- External Link Icon -->
                <a :href="data.item.additional_information_link" style="margin-right: 5px; margin-left: 10px"
                  target="_blank">
                  <b-avatar variant="light-danger" size="30">
                    <feather-icon icon="ExternalLinkIcon" size="15" class="text-danger" />
                  </b-avatar>
                </a>
                <div>
                  <a @click="() => openDetailModal(data.item)" style="margin-right: 3px">
                    <b-avatar variant="light-danger" size="30">
                      <feather-icon icon="InfoIcon" size="15" class="text-danger" /> </b-avatar></a>
                </div>
              </div>
              <div class="">
                <div class="d-flex mt-1">
                  <span class="badge badge-secondary mr-1" v-if="data.item.gre_requirement === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">GRE Required</span>
                  <span class="badge badge-secondary mr-1" v-if="
                    data.item.gre_score !== null &&
                    !isNaN(data.item.gre_score)
                  " style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">
                    {{ data.item.gre_score }}
                  </span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.fifteen_years_education_acceptable === 'Y'"
                    style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">15 years accepted</span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.ielts_waiver === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">IELTS Waiver</span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.stem_course === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">STEM</span>
                  <span class="badge badge-secondary mr-1" v-if="
                    data.item.sat_score !== null &&
                    !isNaN(data.item.sat_score)
                  " style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">
                    {{ data.item.sat_score }}
                  </span>
                </div>
              </div>
            </template>

            <template #cell(application_chat)="data">
              <div>
                <feather-icon :badge="data.item.unread_chat_count" style="cursor: pointer" icon="MessageSquareIcon"
                  size="20" @click="showApplicationChatModal(data.item.sa_mapper_id)" />
              </div>
            </template>

            <template #cell(status_change_date)="data">
              <div style="width: max-content">
                {{
                  data.item.status_change_date
                    ? getDateTimeFormatted(data.item.status_change_date)
                    : ""
                }}
              </div>
            </template>

            <template #cell(commission)="data">
              <div v-if="user_type === 'counselor'">
                <b-form-select :value="data.item.commission" @input="onCommission($event, data.item.sa_mapper_id)">
                  <b-form-select-option value="25">25</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="75">75</b-form-select-option>
                </b-form-select>
              </div>
              <div v-else-if="user_type === 'agent'">
                {{ data.item.commission }}
              </div>
            </template>

            <template #cell(applied_on)="data">
              <div style="width: max-content">
                {{
                  data.item.applied_on
                    ? getDateTimeFormatted(data.item.applied_on)
                    : getDateTimeFormatted(data.item.sa_created_at)
                }}
              </div>
            </template>

            <!-- Hrishikesh copy this for pages/StudentApplications/StudentApplications -->
            <template #cell(application_status)="data">
              <b-form-select style="width: auto" v-if="['operations', 'visa'].includes(user_type)"
                v-model="data.item.status_id" @change="(e) => changeApplicationStatus(e, data.item.sa_mapper_id)
                  ">
                <b-form-select-option v-for="(item, index) in application_statuses" :key="'statuses_ ' + index"
                  :value="item.status_id">
                  {{ item.status_name }}
                </b-form-select-option>
              </b-form-select>
              <p v-else>
                {{ data.item.status_name }}
              </p>
            </template>

            <template #cell(comments)="data">
              <b-form-input style="width: auto" v-if="['operations', 'visa'].includes(user_type)"
                :value="data.item.comments" @input="setApplicationComment($event, data.item.sa_mapper_id)" />
              <p style="width: auto" v-else>{{ data.item.comments }}</p>
            </template>
            <template v-if="['agent', 'franchise'].includes(user_type)" #cell(cancel)="data">
              <div role="button" class="text-center" @click="(e) => {
                  cancelApplication(data.item);
                }
                ">
                <b-avatar variant="light-danger" size="30">
                  <feather-icon icon="TrashIcon" size="15" class="text-danger" />
                </b-avatar>
              </div>
            </template>
          </b-table>
        </b-tab>

        <!-- Favourites -->
        <b-tab v-if="!['operations', 'visa'].includes(user_type)" title="Student Favourites">
          <b-table ref="refStudentFavouritesTable" class="position-relative" :items="studentFavourites" responsive
            :fields="studentFavouritesColumns" primary-key="course_id">
            <template #cell(university_name)="data">
              <div style="width: max-content">
                {{ data.value }}
              </div>
            </template>
            <template #cell(course_fee_pa)="data">
              <div style="width: max-content">
                {{ data.value.toLocaleString("en-IN") }}
                {{ data.item.currency }}
              </div>
            </template>
            <template #cell(course_name)="data">
              <div style="width: max-content">
                {{ data.value }}
              </div>
              <div class="d-flex align-items-center">
                <!-- {{ data.value }} -->
                <!-- External Link Icon -->
                <a :href="data.item.additional_information_link" style="margin-right: 5px; margin-left: 10px"
                  target="_blank">
                  <b-avatar variant="light-danger" size="30">
                    <feather-icon icon="ExternalLinkIcon" size="15" class="text-danger" />
                  </b-avatar>
                </a>
                <div>
                  <a @click="() => openDetailModal(data.item)" style="margin-right: 3px">
                    <b-avatar variant="light-danger" size="30">
                      <feather-icon icon="InfoIcon" size="15" class="text-danger" /> </b-avatar></a>
                </div>
              </div>
              <div class="">
                <div class="d-flex mt-1">
                  <span class="badge badge-secondary mr-1" v-if="data.item.gre_requirement === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">GRE Required</span>
                  <span class="badge badge-secondary mr-1" v-if="
                    data.item.gre_score !== null &&
                    !isNaN(data.item.gre_score)
                  " style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">
                    {{ data.item.gre_score }}
                  </span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.fifteen_years_education_acceptable === 'Y'"
                    style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">15 yrs edu accepted</span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.ielts_waiver === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">IELTS Waiver</span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.stem_course === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">Stem Course</span>
                  <span class="badge badge-secondary mr-1" v-if="
                    data.item.sat_score !== null &&
                    !isNaN(data.item.sat_score)
                  " style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">{{ data.item.sat_score }}</span>
                </div>
              </div>
            </template>
            <template #cell(course_year)="data">
              <div style="width: max-content">
                <div v-if="data.value">{{ data.value }} Year(s)</div>
                <div v-if="data.item.course_month" style="margin-top: 10px">
                  {{ data.value }} Month(s)
                </div>
              </div>
            </template>
            <template #cell(intake)="data">
              <div style="width: max-content">
                {{ formatCourseIntake(data.value) }}
              </div>
            </template>

            <template #cell(course_month)="data">
              <div style="width: max-content">
                <div>{{ data.value }}</div>
              </div>
            </template>
          </b-table>
        </b-tab>

        <!-- Recommendations -->
        <b-tab v-if="!['operations', 'visa'].includes(user_type)" title="Away Recommendations">
          <b-table ref="refSuggestedCoursesTable" class="position-relative" :items="suggestedCourses" responsive
            :fields="suggestedCoursesColumns" primary-key="course_id">
            <template #cell(university_name)="data">
              <div style="width: max-content">
                {{ data.value }}
              </div>
            </template>
            <template #cell(course_fee_pa)="data">
              <div style="width: max-content">
                {{ data.value.toLocaleString("en-IN") }}
                {{ data.item.currency }}
              </div>
            </template>
            <template #cell(course_name)="data">
              <div style="width: max-content">
                {{ data.value }}
              </div>
              <div class="d-flex align-items-center">
                <!-- {{ data.value }} -->
                <!-- External Link Icon -->
                <a :href="data.item.additional_information_link" style="margin-right: 5px; margin-left: 10px"
                  target="_blank">
                  <b-avatar variant="light-danger" size="30">
                    <feather-icon icon="ExternalLinkIcon" size="15" class="text-danger" />
                  </b-avatar>
                </a>
                <div>
                  <a @click="() => openDetailModal(data.item)" style="margin-right: 3px">
                    <b-avatar variant="light-danger" size="30">
                      <feather-icon icon="InfoIcon" size="15" class="text-danger" /> </b-avatar></a>
                </div>
              </div>
              <div class="">
                <div class="d-flex mt-1">
                  <span class="badge badge-secondary mr-1" v-if="data.item.gre_requirement === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">GRE Required</span>
                  <span class="badge badge-secondary mr-1" v-if="
                    data.item.gre_score !== null &&
                    !isNaN(data.item.gre_score)
                  " style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">
                    {{ data.item.gre_score }}
                  </span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.fifteen_years_education_acceptable === 'Y'"
                    style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">15 years accepted</span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.ielts_waiver === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">IELTS Waiver</span>
                  <span class="badge badge-secondary mr-1" v-if="data.item.stem_course === 'Y'" style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">STEM</span>
                  <span class="badge badge-secondary mr-1" v-if="
                    data.item.sat_score !== null &&
                    !isNaN(data.item.sat_score)
                  " style="
                      color: #fff;
                      background-color: #00e87c;
                      border-radius: 9999px;
                    ">{{ data.item.sat_score }}</span>
                </div>
              </div>
            </template>
            <template #cell(course_year)="data">
              <div style="width: max-content">
                <div v-if="data.value">{{ data.value }} Year(s)</div>
                <div v-if="data.item.course_month" style="margin-top: 10px">
                  {{ data.item.course_month }} Month(s)
                </div>
              </div>
            </template>
            <template #cell(intake)="data">
              <div style="width: max-content">
                {{ formatCourseIntake(data.value) }}
              </div>
            </template>
            <template #cell(action)="data">
              <div class="text-center">
                <b-dropdown text="Actions" variant="secondary">
                  <b-dropdown-item
                    v-if="data.item.student_response === 'pending' && ['agent', 'franchise'].includes(user_type)"
                    @click="acceptSuggestionForStudent(data.item.course_id)">
                    Accept
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.student_response === 'pending' && ['agent', 'franchise'].includes(user_type)"
                    @click="rejectSuggestionForStudent(data.item.course_id)">
                    Reject
                  </b-dropdown-item>
                  <b-dropdown-item @click="removeRecommendation(data.item.course_id)">
                    Remove
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormTextarea,
  BButton,
  BTable,
  BMedia,
  BModal,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormSelect,
  BFormSelectOption,
  BImg,
  BTabs,
  BTab,
} from "bootstrap-vue";
// import JsonExcel from "vue-json-excel";
import CommonServices from "@/apiServices/CommonServices";
import store from "@/store";
import OperationsServices from "@/apiServices/OperationsServices";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import AgentServices from "@/apiServices/AgentServices";
import helpers from "@/libs/helpers";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import CounselorServices from "@/apiServices/CounselorServices";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BMedia,
    BFormInput,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BFormSelectOption,
    BImg,
    // JsonExcel,
    FeatherIcon,
    BFormTextarea,
    BTabs,
    BTab,
  },
  data() {
    return {
      popupData: null,
      student_user_id: null,
      modalVisible: false,
      application_limit: 0,

      application_statuses: [],

      studentApplications: [],
      studentFavourites: [],
      suggestedCourses: [],

      sa_mapper_id: null,
      chatMessage: "",
      applicationChat: [],
      getApplicationChatInterval: null,

      // studentApplicationsExcelFeild: {
      //   Country: "country_name",
      //   University: "university_name",
      //   Course: "course_name",
      //   Level: "course_level_name",
      //   Category: "course_category_name",
      //   "Intake Month": "intake_month",
      //   "Intake Year": "intake_year",
      //   Status: "application_status",
      //   "Status Change Date": "status_change_date",
      //   "Applicaion Date": "applied_on",
      // },

      studentApplicationsColumns: [
        // { key: "No", label: "#" },
        { key: "sa_mapper_id", label: "Application Id" },
        { key: "country_name", label: "Country" },
        { key: "university_name", label: "University" },
        { key: "course_name", label: "Course" },
        { key: "course_year", label: "Duration" },
        { key: "intake", label: "Intake Months" },
        { key: "course_fee_pa", label: "Course Fee (P.A.)" },

        { key: "sa_campus_locations", label: "Campus Locations" },

        // { key: "course_level_name", label: "Level" },
        // { key: "course_category_name", label: "Category" },
        { key: "intake_month", label: "Intake Month" },
        { key: "intake_year", label: "Intake Year" },
        { key: "application_chat", label: "Chat" },
        { key: "application_status", label: "Status" },
        { key: "comments", label: "Comments" },
        {
          key: "status_change_date",
          label: "Status Change Date",
          // formatter: helpers.getDateTimeFormatted,
        },
        {
          key: "applied_on",
          label: "Application Date",
          // formatter: helpers.getDateTimeFormatted,
        },
      ],

      studentFavouritesColumns: [
        // { key: "No", label: "#" },
        { key: "country_name", label: "Country" },
        { key: "university_name", label: "University" },
        { key: "course_name", label: "Course" },

        { key: "course_year", label: "Duration" },
        { key: "intake", label: "Intake Months" },
        // {key:"course_month", label:"Duration (Months)"},
        { key: "course_fee_pa", label: "Fee (P.A.)" },
        // { key: "course_level_name", label: "Level" },
        // { key: "course_category_name", label: "Category" },
      ],

      suggestedCoursesColumns: [
        // { key: "No", label: "#" },
        { key: "country_name", label: "Country" },
        { key: "university_name", label: "University" },
        { key: "course_name", label: "Course" },

        { key: "course_year", label: "Duration" },
        { key: "intake", label: "Intake Months" },
        // {key:"course_month", label:"Duration (Months)"},

        { key: "course_fee_pa", label: "Fee (P.A.)" },
        // { key: "course_level_name", label: "Level" },
        // { key: "course_category_name", label: "Category" },
        { key: "student_response", label: "Student Response" },
        // { key: "apply" },
        // { key: "reject" },
        // { key: "action", label: "Action" },
      ],

      on_commission: null,

      commentsDebounce: null,
    };
  },

  computed: {
    user_type() {
      if (store.getters["user/getUserDetails"].user_type) {
        let type = store.getters["user/getUserDetails"].user_type;
        if (["agent", "franchise"].includes(type)) {
          if (
            !this.studentApplicationsColumns.includes({
              key: "cancel",
              label: "Cancel",
            })
          ) {
            this.studentApplicationsColumns.push({
              key: "cancel",
              label: "Cancel",
            });
          }
        }
        if (["counselor", "agent", "franchise"].includes(type)) {
          if (
            !this.suggestedCoursesColumns.includes({
              key: "action",
              label: "Action",
            })
          ) {
            this.suggestedCoursesColumns.push({
              key: "action",
              label: "Action",
            });
          }
        }
        if (["counselor", "agent"].includes(type)) {
          if (
            !this.studentApplicationsColumns.includes({
              key: "commission",
              label: "Commission %",
            })
          ) {
            this.studentApplicationsColumns.push({
              key: "commission",
              label: "Commission %",
            });
          }
        }
        return type;
      } else {
        return null;
      }
    },
  },

  methods: {
    async setApplicationComment(i, sa_mapper_id) {
      if (this.commentsDebounce) clearTimeout(this.commentsDebounce);

      this.commentsDebounce = setTimeout(async () => {
        const response = await OperationsServices.setApplicationComments({
          student_user_id: this.student_user_id,
          comments: i,
          application_id: sa_mapper_id,
        });
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Comment Updated",
              icon: "Check",
              variant: "success",
            },
          });
          this.getStudentApplications(this.student_user_id);
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Comment not updated",
              icon: "X",
              variant: "primary",
            },
          });
        }
      }, 1000);
    },

    onCommission(commission, sa_mapper_id) {
      if (this.on_commission) clearTimeout(this.on_commission);
      this.on_commission = setTimeout(async () => {
        const response =
          await CounselorServices.saveAgentCommissionForApplication({
            sa_mapper_id: sa_mapper_id,
            commission: commission,
            student_user_id: this.student_user_id,
          });

        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Success",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Failed",
              icon: "EditIcon",
              variant: "primary",
            },
          });
        }
      }, 1000);
    },
    onDetailModalClose() {
      this.popupData = {};
    },
    openDetailModal(data) {
      // console.log("popupData => ",data);
      this.popupData = data;
      this.$refs.detailModal.show();
    },

    formatCourseIntake(intake) {
      return intake;
    },

    async loadApplicationChat() {
      try {
        const res = await CommonServices.getApplicationChat({
          sa_mapper_id: this.sa_mapper_id,
          student_user_id: this.student_user_id,
        });

        this.applicationChat = res.data.data;
      } catch (error) {
        console.error("Error in loadApplicationChat", error);
      }
    },

    async showApplicationChatModal(sa_mapper_id) {
      this.$refs["applicationChatModal"].show();

      this.sa_mapper_id = sa_mapper_id;

      await this.loadApplicationChat();

      this.getApplicationChatInterval = setInterval(
        this.loadApplicationChat,
        5000
      );
    },

    onApplicationModalClose() {
      clearInterval(this.getApplicationChatInterval);
      this.applicationChat = [];
      this.$refs["applicationChatModal"].hide();
    },

    async sendApplicationMessage() {
      await CommonServices.sendApplicationChat({
        sa_mapper_id: this.sa_mapper_id,
        student_user_id: this.student_user_id,
        message: this.chatMessage,
      });
      this.chatMessage = "";
      await this.loadApplicationChat();
    },

    // getExcelData() {
    //   return this.studentApplications.map((application) => {
    //     return {
    //       ...application,
    //       application_status: application.status_id
    //         ? this.application_statuses.find(
    //             (as) => as.status_id == application.status_id
    //           ).status_name
    //         : "",
    //       applied_on: application.applied_on
    //         ? this.getDateTimeFormatted(application.applied_on)
    //         : this.getDateTimeFormatted(application.sa_created_at),
    //     };
    //   });
    // },

    getDateTimeFormatted: helpers.getDateTimeFormatted,
    async cancelApplication(course) {
      if (course.status_id > 1) {
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: "Cannot Cancel this Application",
            icon: "X",
            variant: "failure",
          },
        });
        return;
      }

      try {
        const response = await AgentServices.cancelApplicationForStudent({
          student_user_id: this.student_user_id,
          course_id: course.course_id,
        });
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Application Canceled",
              icon: "Check",
              variant: "succes",
            },
          });
          this.getStudentApplications(this.student_user_id);
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Application Not Canceled",
              icon: "X",
              variant: "failure",
            },
          });
        }
      } catch (err) {
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: "Error in canceling application",
            icon: "X",
            variant: "failure",
          },
        });
        console.log("Error in getting  ", err);
      }
    },
    async changeApplicationStatus(status_id, application_id) {
      try {
        const response = await OperationsServices.setApplicationStatus({
          student_user_id: this.student_user_id,
          status_id,
          application_id,
        });
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Status Updated",
              icon: "Check",
              variant: "success",
            },
          });
          this.getStudentApplications(this.student_user_id);
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Status not updated",
              icon: "X",
              variant: "failure",
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async removeRecommendation(course_id) {
      try {
        if (!this.student_user_id) return;

        const response = await CommonServices.removeRecommendation({
          student_user_id: this.student_user_id,
          course_id,
        });
        if (response.data.status) {
          this.getStudentApplications(this.student_user_id);
        }
      } catch (error) {
        console.error("Error in canceling Suggestion ", error);
      }
    },
    async getStudentApplications(student_user_id) {
      try {
        const response = await CommonServices.getStudentApplications({
          student_user_id,
        });
        if (response.data.status) {
          const { applications, favourites, suggestions } = response.data.data;

          this.studentApplications = applications;
          this.studentFavourites = favourites;
          this.suggestedCourses = suggestions;

          // this.checkCounselor();
        }
      } catch (error) {
        console.error("Error in getting student applications ", error);
      }
    },
    async getApplicationStatuses() {
      try {
        const response = await CommonServices.getAllApplicationStatuses();

        if (response.data.status) {
          this.application_statuses = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async acceptSuggestionForStudent(course_id) {
      AgentServices.acceptSuggestionForStudent({
        student_user_id: this.student_user_id,
        course_id,
      })
        .then((response) => {
          if (response.data.status) {
            this.getStudentApplications(this.student_user_id);
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Success",
                icon: "Check",
                variant: "Success",
              },
            });
          }
        })
        .catch((err) => {
          console.log("Error in accepting course suggestion ", err);
        });
    },
    async rejectSuggestionForStudent(course_id) {
      AgentServices.rejectSuggestionForStudent({
        student_user_id: this.student_user_id,
        course_id,
      })
        .then((response) => {
          if (response.data.status) {
            this.getStudentApplications(this.student_user_id);
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Success",
                icon: "Check",
                variant: "Success",
              },
            });
          }
        })
        .catch((err) => {
          console.log("Error in rejecting course suggestion ", err);
        });
    },
  },

  beforeMount() {
    const { student_user_id } = this.$route.params;
    if (!isNaN(student_user_id)) {
      this.getStudentApplications(student_user_id);
      this.student_user_id = student_user_id;
      this.getApplicationStatuses();
    } else {
      console.log("Student User Id is is not a number ", student_user_id);
    }
  },
};
</script>

<style>
.course-detail__sm-title {
  font-weight: bold;
  /* text-decoration: underline; */
  text-transform: uppercase;
}

.no-style-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.AliifChat-chatbox {
  width: 460px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  overflow-x: hidden;
}

.chat-header {
  background-color: #00e87c;
  color: #fff;
  text-align: center;
  padding: 14px 0;
  font-weight: bold;
  border-bottom: 2px solid #5367ff;
}

.chat-messages {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
  overflow-x: hidden;
}

.message {
  margin-bottom: 10px;
}

.user-info {
  margin-right: 10px;
}

.user-name {
  font-weight: bold;
}

.user-type {
  font-size: 12px;
  color: #777;
}

.message-text {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 8px 12px;
  word-break: break-word;
}

.message-content {
  word-wrap: break-word;
}

.message-timestamp {
  font-size: 7px;
  padding-left: 5px;
  color: #777;
}

.chat-input {
  padding-top: 10px;
  margin-left: 15px;
  margin-right: 15px;

  border-top: 1px solid #5367ff;
}

.send-button {
  background-color: #00e87c;
  color: #5367ff;
  font-weight: bold;
  border: 1px solid #5367ff;
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
}

.send-button:hover {
  background-color: #5367ff;
  color: #00e87c;
}

/* .per-page-selector {
  width: 90px;
} */
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
